import { css } from "@emotion/core";
import { fontSizes, color } from "../../constants/commons";

export const registrationPageStyle = css`
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-margin-style {
      background: white;
      padding: 2em 0;
    }
    .mt-25 {
      margin-top: 0.2em;
    }
    .save-exit-style {
      font-size: ${fontSizes.xxs};
      text-align: right;
    }
    .fixed-custom-navbar-style {
      position: fixed;
      top: 0em;
      z-index: 4;
      background: ${color.white};
      padding: 1em 0.5em;
      width: 100%;
      box-shadow: 0 0.25em 0.625em 0 ${color.shadow};
    }
    .registration-custom-padding-responsive {
      padding: 4em 0 1em 0;
    }
    .custom-full-height {
      min-height: 100vh;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-margin-style {
      margin: 2em 0 0 0;
    }
    .responsive-margin {
      min-height: 100vh;
      margin-bottom: 4em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-margin-style {
      margin: 3.5em 0 0 0;
    }
    .responsive-margin {
      margin: 3em 0 0 0;
      min-height: 100vh;
      margin-bottom: 6em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-margin-style {
      margin: auto;
      max-width: 60.5em;
    }
    .responsive-margin {
      margin-bottom: 8em;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-margin-style {
      margin: auto;
      max-width: 51.5em;
    }
    .responsive-margin {
      margin: auto;
      max-width: 51.5em;
      margin-bottom: 8em;
    }
  }
`;
